import { BenefitTypeResolver } from './benefit-type.resolver';
import { DeductionTypeResolver } from './deduction-type.resolver';
import { PayrollPendingStateResolver } from './payroll-pending-state.resolver';

const Resolvers = [BenefitTypeResolver, DeductionTypeResolver, PayrollPendingStateResolver];

export { Resolvers, BenefitTypeResolver, DeductionTypeResolver, PayrollPendingStateResolver };
